import {
    GoogleAuthProvider,
    onAuthStateChanged,
    signInWithRedirect,
    signOut,
    User
} from "@firebase/auth";
import Vue from "vue";
import {
    auth,
    createSessionGroup,
    getTiledImages,
    initFirebase,
    isAdmin,
    listenSessionGroups,
    setUserSecret,
    updateSessionGroupCounts
} from "../domain/domain";

interface AdminSessionGroup {
    session_group_name: string,
        session_group_description: string,
        session_group_secret: string,
        link ? : string,
        constellation_link ? : string
}

function uuidv4() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
        var r = (Math.random() * 16) | 0,
            v = c == "x" ? r : (r & 0x3) | 0x8;
        1
        return v.toString(16);
    });
}

function getSessionUrl(): URL {
    var url = new URL(document.location.href);
    let path_list = url.pathname.split("/");
    path_list.pop();
    let path = path_list.join("/");
    if (path.slice(-1) != '/') path += '/';
    url.pathname = path + "session.html";
    return url;
}


export function adminPage() {
    initFirebase();

    var app = new Vue({
        el: "#app",

        data: {
            loggedIn: false,
            loginStatus: "validating",
            user: < User | null > null,

            sessionGroupName: "",
            sessionGroupDescription: "",

            sessionGroups: < {
                [key: string]: AdminSessionGroup
            } > {},
        },

        methods: {
            doLogin: () => signInWithRedirect(auth, new GoogleAuthProvider()),
            doLogout: () => signOut(auth),
            updateImageCount: function() {
                Object.keys(app.sessionGroups).forEach((session_group) => updateSessionGroupCounts(session_group));
            },
            doSubmitForm: function () {
                var secret = uuidv4();
                var session_group_name = this.sessionGroupName;
                var session_group_description = this.sessionGroupDescription;

                if (!app.user) return;

                setUserSecret(app.user.uid, secret).then(() =>
                    createSessionGroup(session_group_name, session_group_description, secret)
                ).catch((x) => {
                    alert(x);
                });

                app.sessionGroupName = "";
                app.sessionGroupDescription = "";
            },
            getTiledImages: function () {
                let images = getTiledImages();
                images.then((data) => {
                    data = Object.values(data).map((x:any) => {
                        x.tiles = Object.values(x.tiles);
                        return x;
                    });
                    
                    console.log(JSON.stringify(data));
                    const blob = new Blob([JSON.stringify(data)], { type: "application/json" });

                    const a = document.createElement('a');
                    a.href = URL.createObjectURL(blob);
                    a.download = "tiled_images.json";
                    a.style.display = 'none';
                  
                    document.body.appendChild(a);
                    a.click();
                  
                    document.body.removeChild(a);
                    URL.revokeObjectURL(a.href); // Clean up
                  
                    console.log('File has been downloaded.');    
                });
            }
        },
    });

    onAuthStateChanged(auth, function (authUser) {
        app.loggedIn = authUser && !authUser.isAnonymous || false;
        app.loginStatus = "validating";
        app.user = authUser;

        if (authUser) {
            isAdmin(authUser.uid).then((is_admin) => {
                if (is_admin) {
                    app.loginStatus = "good";

                    listenSessionGroups((session_group_map) => {
                        app.sessionGroups = session_group_map;

                        for (var key in app.sessionGroups) {
                            app.sessionGroups[key].link =
                                getSessionUrl().toString().split("#")[0] +
                                "?session_group=" +
                                key +
                                "&secret=" +
                                app.sessionGroups[key].session_group_secret;

                            app.sessionGroups[key].constellation_link = new URL("constellation-simple.html?session_group=" + key, document.baseURI).href
                        }
                    });
                } else {
                    app.loginStatus = "bad_user";
                }
            });
        } else {
            app.loginStatus = "not_logged_in";
        }
    });
}